import store from '@/store'
import { realEstatesService } from '@/services/realEstates.service'
import { HZ_INVESTOR_ONBOARDING_PATHNAME } from '@/router/constants'
import { proPersonalAssetsRoute } from '@/router/routes/contants'

/**
 * Middleware — vérifie que l'utilisateur a au moins un bien enregistré.
 * Si aucun bien : redirige vers l'onboarding "Ajouter un bien".
 * Si au moins un bien : laisse passer au middleware suivant.
 *
 * Ce middleware doit être placé AVANT checkPermission dans la chaîne,
 * pour éviter qu'un utilisateur payant sans bien voie le message
 * "Votre abonnement ne vous permet pas d'effectuer cette action"
 * alors que son abonnement est valide — il n'a juste pas encore de bien.
 */
export default async function checkHasRealEstates({ next }) {
  const count = await realEstatesService.getRealEstateNumber()

  if (count.count > 0) {
    return next()
  }

  // Agence (abonné Horiz Pro) sans bien : pas d'onboarding propriétaire, invitation à un
  // compte particulier pour suivre son patrimoine (performance, revenus).
  if (store.getters['auth/isPro']) {
    return { path: proPersonalAssetsRoute.path }
  }

  return { path: HZ_INVESTOR_ONBOARDING_PATHNAME }
}
